module.exports = __webpack_public_path__ + "img/e_3_8_g.dc1c7ded.png";